import { render, staticRenderFns } from "./TripExperience.vue?vue&type=template&id=2967d5f1&"
import script from "./TripExperience.vue?vue&type=script&lang=js&"
export * from "./TripExperience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports